export const dict = {
    PleaseEnterYourNewPassword: "Please Enter Your New Password",
    ChangePassword: "Change Password",
    NotEqual: "Passwords are not Equal",
    ServerError: "Server Error",
    Continue: "Continue",
    Invalid: "New password is invalid",
    PasswordReset: "Password Reset",
    "password-reset-button": "Reset password",
    "password-was-previously-in-use": "	Password was previously in use",
    PlayerApiNotSupported: "Player api is not supported",
    PRT_TOKEN_IS_NOT_VALID: "This page no longer exists",
    Sorry: "Sorry",
    Close: "Close",
    PasswordResetPasswordError: "PasswordResetPasswordError",
    PasswordChangedTitle: "Password has been changed title",
    PasswordChangedBody: "Password has been changed body",
    YourPasswordHasExpiredMsg: "Your password has expired. To proceed with Login, please create a new password for your account."
};
//# sourceMappingURL=dict.js.map